export default __webpack_public_path__ + "static/media/Swim_Team_16_9.66a0ba61.png";